import { withFormik } from 'formik';
import { Button, SmallText } from 'hui';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import * as yup from 'yup';

const Input = styled.input`
  display: block;
  margin-top: 1em;
  border-radius: ${props => props.theme.radius.element};
  border: 1px solid ${props => props.theme.colors.tint3};
  padding: 0.5rem;
  width: 100%;

  &:not(:first-child) {
    margin-top: 1rem;
  }

  &:disabled,
  &[disabled] {
    background-color: ${props => props.theme.colors.tint3};
  }
`;

export const NewsletterSubscriptionForm = ({
  isSubmitting,
  errors,
  touched,
  handleSubmit,
  handleChange,
  handleBlur
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <input type="hidden" name="from" disabled={isSubmitting} />
      <Input
        name="fullname"
        placeholder="Name"
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isSubmitting}
      />
      {touched.fullname && errors.fullname && (
        <SmallText color="danger" mb={1}>
          {errors.fullname}
        </SmallText>
      )}
      <Input
        name="email"
        placeholder="Email"
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isSubmitting}
      />
      {touched.email && errors.email && (
        <SmallText color="danger" mb={1}>
          {errors.email}
        </SmallText>
      )}
      <Input
        name="postcode"
        placeholder="Postcode"
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isSubmitting}
      />
      {touched.postcode && errors.postcode && (
        <SmallText color="danger" mb={1}>
          {errors.postcode}
        </SmallText>
      )}
      <Button color="tint1" block mt={1} disabled={isSubmitting}>
        Subscribe
      </Button>
    </form>
  );
};

NewsletterSubscriptionForm.propTypes = {
  isSubmitting: PropTypes.bool,
  errors: PropTypes.object,
  touched: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func
};

const FormikNewsletterSubscriptionForm = withFormik({
  mapPropsToValues: () => ({
    from: '/consumer/newsletter-signup-postcode',
    fullname: '',
    email: '',
    postcode: ''
  }),
  validationSchema: yup.object().shape({
    fullname: yup.string().required('Please enter your name'),
    email: yup
      .string()
      .email(`This doesn't look like a valid email...`)
      .required('This field is required'),
    postcode: yup
      .number()
      .integer()
      .required('Please enter your postcode')
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    const { onSubmit = () => {} } = props;

    try {
      setSubmitting(true);
      onSubmit(values);
    } catch (ex) {
      setSubmitting(false);
    }
  }
})(NewsletterSubscriptionForm);

export default FormikNewsletterSubscriptionForm;
